import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  // 사업소개 (탭: 사업개요, 브랜드)
  {
    path: '/intro/:sub',
    name: 'intro',
    component: () => import('../views/web/intro/IntroView.vue')
  },
  // 입지안내
  {
    path: '/location/environment',
    name: 'location',
    component: () => import('../views/web/location/LocationView.vue')
  },
  // 상품안내 (탭: 단지정보, 프리미엄, 커뮤니티)
  {
    path: '/product/:sub',
    name: 'product',
    component: () => import('../views/web/product/ProductView.vue')
  },
  // 타입안내 (59, 74, 84A, 84A-1, 84B)
  {
    path: '/type/:size',
    name: 'type',
    component: () => import('../views/web/type/TypeView.vue')
  },
  // 홍보센터
  {
    path: '/media/video',
    name: 'video',
    component: () => import('../views/web/media/VideoView.vue')
  },
  // 방문예약
  {
    path: '/reservation/register',
    name: 'reservation',
    component: () => import('../views/web/ReservationView.vue')
  },
  // 개인정보처리방침
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/web/PrivacyView.vue')
  },
  // 관리자
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/admin/AdminView.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
